import React, { useState } from 'react';
import { UserService } from '../../services';
import { useNotification } from '../../contexts/NotificationContext';
import CheckBoxIcon from '@material-ui/icons/CheckBox';
import CheckBoxOutlineBlank from '@material-ui/icons/CheckBoxOutlineBlank';
import Alert from '@material-ui/lab/Alert';
import Snackbar from '@material-ui/core/Snackbar';
import { isSuccessfulResponse } from '../../utils/responseHelpers';
import ConfirmationModal from '../../components/ConfirmationModal';

const ActiveUserCell = (props) => {
    const { createErrorNotification } = useNotification();
    const [showWaitMessage, setShowWaitMessage] = useState(false);
    const [showConfirmationBox, setShowConfirmationBox] = useState(false);

    const toggleConfirmation = () => setShowConfirmationBox((prev) => !prev);

    const handleActiveClick = () => toggleConfirmation();

    const handleConfirmActive = async () => {
      await updateActive(!props.value);
      toggleConfirmation();
    }

    const closeWaitMessage = () => {
      setShowWaitMessage(false);
    }

    const updateActive = async (active) => {
        try {
            const response = await UserService.updateActiveUser(props.id, active);
            if (isSuccessfulResponse(response)) {
                setShowWaitMessage(true);
                setTimeout(() => window.location.reload(), 10000);
            } else {
                createErrorNotification("Failed to change active user setting.");
            }
        } catch (err) {
            createErrorNotification("Failed to change active user setting.");
        }
    }

    return (props.value ?
        <div>
          <Snackbar open={showWaitMessage} autoHideDuration={3000} anchorOrigin={{ vertical: 'top', horizontal: 'center' }}>
            <Alert onClose={closeWaitMessage} severity="success">
              {"Deactivating user. Changes will appear in a few seconds."}
            </Alert>
          </Snackbar>
          <CheckBoxIcon onClick={handleActiveClick}/>
          <ConfirmationModal title="Confirm" message="Are you sure you want to deactivate this user?" onConfirm={handleConfirmActive} onCancel={toggleConfirmation} showConfirmationBox={showConfirmationBox}/>
        </div>
        :
        <div>
          <Snackbar open={showWaitMessage} autoHideDuration={3000} anchorOrigin={{ vertical: 'top', horizontal: 'center' }}>
            <Alert onClose={closeWaitMessage} severity="success">
              {"Activating user. Changes will appear in a few seconds."}
            </Alert>
          </Snackbar>
          <CheckBoxOutlineBlank onClick={handleActiveClick}/>
          <ConfirmationModal title="Confirm" message="Are you sure you want to activate this user?" onConfirm={handleConfirmActive} onCancel={toggleConfirmation} showConfirmationBox={showConfirmationBox}/>
        </div>
    )
}

export default ActiveUserCell;
